import React, { ReactNode } from 'react';

import { ListItem, ListItemIcon, ListItemText, ListItemSecondaryAction } from 'e100-react-components';

import { useStyles } from './styles';

export const StationListItem = ({ onClick, actionSlot, icon, children }: StationListItemProps) => {
  const classes = useStyles();

  return (
    <ListItem button={!!onClick} onClick={onClick}>
      <ListItemIcon>
        <img width={44} src={icon} alt={'Station icon'} className={classes.icon} />
      </ListItemIcon>
      <ListItemText primary={children} />
      <ListItemSecondaryAction>{actionSlot}</ListItemSecondaryAction>
    </ListItem>
  );
};

export interface StationListItemProps {
  onClick?: () => void;
  actionSlot?: JSX.Element;
  icon?: string;
  children?: ReactNode;
}
